import { createSelector, OutputSelector } from 'reselect'
import { IShipmentFiltersState } from 'types/shipment'
import { IFiltersState } from 'apps/booking/types'
import { IStore } from 'apps/booking/utils/reducers'

const selectFilters = (state: IStore): IFiltersState => state.filters

interface SelectFilters
  extends OutputSelector<
    IStore,
    {
      searchParams: IShipmentFiltersState
    },
    (
      res: IFiltersState
    ) => {
      searchParams: IShipmentFiltersState
    }
  > {}

export const searchParamsSelector: SelectFilters = createSelector(
  selectFilters,
  ({ searchParams }) => ({ searchParams })
)
